import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { ClientLink, Currency, RouteLink, Widget } from '~/components';
import { useApi, useWorkspace } from '~/contexts';
import Timestamp from './Timestamp.jsx';
import colors from '~/styles/colors.js';

const List = styled.ul`
  li {
    display: flex;
    justify-content: space-between;
    padding: 0.25rem 0;
  }
`;

export default function TopClientsByServicesRevenue({ start, end, setRefetch }) {
  const { workspace } = useWorkspace();

  const api = useApi();
  const [{ data, isReady, timestamp }, setQuery] = useState({ data: null, isReady: false });

  const fetchData = useCallback(
    async (behavior) => {
      try {
        if (workspace.sampleData) behavior = 'bypass';
        const { data, headers } = await api.www
          .workspaces(workspace.id)
          .executiveDashboard()
          .topClientsByServicesRevenue({ start, end }, behavior);
        setQuery({ data, isReady: true, timestamp: headers['x-cache-timestamp'] });
      } catch (error) {
        setQuery({ data: null, isReady: true });
      }
    },
    [workspace.id, workspace.sampleData, api, start, end],
  );

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    setRefetch(() => fetchData('invalidate'));
  }, [fetchData, setRefetch]);

  const currency = workspace.currency;

  return (
    <Widget loading={!isReady}>
      <Widget.Header>
        <Widget.Title>Top Clients by Services Revenue</Widget.Title>
        <Timestamp timestamp={timestamp} dateRange={{ start, end }} onClick={() => fetchData('invalidate')} />
      </Widget.Header>
      <Widget.Preview style={{ minHeight: '20rem' }} />
      <Widget.Content>
        {data &&
          (data.length > 0 ? (
            <List>
              {data.map((item) => (
                <li key={item.id}>
                  <h3>
                    <ClientLink client={item} />
                  </h3>
                  <p>
                    <RouteLink
                      to={`/app/${workspace.key}/reports/performance-by-project?${new URLSearchParams({ client: item.id, start, end })}`}>
                      <Currency currency={currency} value={item.revenue} />
                    </RouteLink>
                  </p>
                </li>
              ))}
            </List>
          ) : (
            <p style={{ color: colors.grey25 }}>No data available.</p>
          ))}
      </Widget.Content>
    </Widget>
  );
}
